/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateBankTransferMembershipsOrderResponse } from '../../models/create-bank-transfer-memberships-order-response';
import { MembershipsOrderRequest } from '../../models/memberships-order-request';

export interface CreateBankTransferMembershipsOrder$Params {
      body: MembershipsOrderRequest
}

export function createBankTransferMembershipsOrder(http: HttpClient, rootUrl: string, params: CreateBankTransferMembershipsOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateBankTransferMembershipsOrderResponse>> {
  const rb = new RequestBuilder(rootUrl, createBankTransferMembershipsOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateBankTransferMembershipsOrderResponse>;
    })
  );
}

createBankTransferMembershipsOrder.PATH = '/api/company/memberships/create-bank-transfer-order';
